import SectionSubGroup from "@components/SectionGroup/SectionSubGroup"
import ShopIcon from "@components/ShopIcon/ShopIcon"
import { Shop } from "@interfaces/Shops"
import Localization from "@localization/Index"
import { useMobileMediaQuery } from "@utils/MediaComponents"
import { getCloudStoreShop, getShopStatus } from "@utils/ShopsUtils"
import { CloudStoreShopIdEnum } from "cs.node.utils/ShopUtils"
import { useNavigate } from "react-router"

type Props = {
    shop: Shop
}

const HeaderSearchBarResultShop = (props: Props) => {
    const { shop } = props
    const navigate = useNavigate()
    const isMobile = useMobileMediaQuery()

    const csShop = getCloudStoreShop(shop?.cs_shop_id?.$oid!)
    const isFarfetch = shop.cs_shop_id?.$oid === CloudStoreShopIdEnum.Farfetch
    const isSecondary = !!shop?.config?.primary_shop_id
    const {bg} = getShopStatus(shop.status ?? "")

    if(isMobile) {
        return <div className="row my-2 py-4 w-100" style={{borderBottom: '1px dashed var(--bs-gray-gray-300'}} onClick={(e)=>{
            const link = csShop?.isChannel? `/shops/channel/${shop?.cs_shop_id?.$oid!}`: `/shops/${shop?.cs_shop_id?.$oid!}/${shop?._id?.$oid}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
            <div className="col-4 d-flex align-items-center justify-content-start" style={{opacity: shop.enabled?1:0.4}}>
                <ShopIcon id={shop?.cs_shop_id?.$oid ?? ""} size={18} />
                {isFarfetch && isSecondary && <span className="ms-1 badge bg-warning">SE</span>}
                {isFarfetch && !isSecondary && <span className="ms-1 badge bg-primary">PR</span>}
            </div>
            <div className="col-12 d-flex flex-column align-items-start justify-content-center">
                <div className="fw-bold cs-link small" style={{opacity: shop.enabled?1:0.5}}>{shop?.name}</div>
                <div style={{opacity: shop.enabled?1:0.5}}>{shop.customer_code}</div>
            </div>
            <div className="col-8 text-end">
                <span className={`badge fw-600 text-black bg-${bg}-light`} style={{opacity: shop.enabled?1:0.5}}>{Localization.PAGE_SHOPS.FILTERS[shop.status!]}</span>
            </div>
        </div>
    }

    return <SectionSubGroup small className="w-100" role="button" onClick={(e)=>{
            const link = csShop?.isChannel? `/shops/channel/${shop?.cs_shop_id?.$oid!}`: `/shops/${shop?.cs_shop_id?.$oid!}/${shop?._id?.$oid}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
            <div className="row">
                <div className="d-flex align-items-center justify-content-start col-8">
                    <div className="d-flex flex-column align-items-start justify-content-center ms-4">
                        <div className="fw-bold cs-link small" style={{opacity: shop.enabled?1:0.5}}>{shop?.name}</div>
                    </div>
                </div>
                <div className="col-8">
                    <span style={{opacity: shop.enabled?1:0.4}}>
                        <ShopIcon extended id={shop?.cs_shop_id?.$oid ?? ""} size={18} />
                        {isFarfetch && isSecondary && <span className="ms-1 badge bg-warning">SE</span>}
                        {isFarfetch && !isSecondary && <span className="ms-1 badge bg-primary">PR</span>}
                    </span>
                </div>
                <div className="col-2">
                    <span style={{opacity: shop.enabled?1:0.5}}>{shop.customer_code}</span>
                </div>
                <div className="col-3">
                    <span className={`badge fw-600 text-black bg-${bg}-light`} style={{opacity: shop.enabled?1:0.5}}>{Localization.PAGE_SHOPS.FILTERS[shop.status!]}</span>
                </div>
                <div className="col-3">
                    <span style={{opacity: shop.enabled?1:0.5}}>{shop?.enabled?Localization.PAGE_SHOPS.TABLE.ABILITATO:Localization.PAGE_SHOPS.TABLE.DISABILITATO}</span>
                </div>
            </div>
        </SectionSubGroup>
}

export default HeaderSearchBarResultShop